exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".admin-main {\n  max-width: 1240px;\n  padding: 5px 20px 20px 22px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/admin/admin.less
// module id = 1340
// module chunks = 0